module.exports = __webpack_public_path__ + "static/img/36-1.f51981a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/36-1.jpg
// module id = ypiW
// module chunks = 0